import React from 'react';

import { ICustomOptionProps } from 'common/components/FieldGenerator/types';
import classNames from 'classnames';
import { useTranslateFn } from 'utils/useTranslateFn';
import { TranslationKey } from '@danfloss/utils/text-translations';
import CachedImage from 'common/components/CachedImage';
import styles from './styles.module.scss';

const HoseProductOption = React.memo(({
  option: { title, attributes },
}: ICustomOptionProps) => {
  const attrs = (attributes || {}) as Record<string, string>;
  const gridClass = classNames({
    [styles.content]: true,
    [styles.content4]: true,
  });
  console.log(gridClass)
  const t = useTranslateFn<TranslationKey>();
  const defaultImageHose = t('variables.hoseNoImage');
  return (
    <div className={gridClass}>
      <span className={styles.image}>
        <CachedImage
          src={attributes?.image || defaultImageHose}
          alt={title}
        />
      </span>
      <span>{title}</span>
      <span className={styles.moreLeft}>
        {`${attrs?.description}`}
      </span>
      <span className={styles.more}>
        {`${attrs?.working_pressure}(psi)`}
      </span>
      <span className={styles.more}>
        Min
        {' '}
        {`${attrs?.temperature_min_f} (deg F)`}
        -
        Max
        {' '}
        {`${attrs?.temperature_max_f} (deg F)`}
      </span>
    </div>
  );
}, (prevProps, nextProps) => (
  prevProps.option.id === nextProps.option.id
  && prevProps.option.title === nextProps.option.title
  && prevProps.option.attributes?.image === nextProps.option.attributes?.image
));

HoseProductOption.displayName = 'HoseProductOption';

export default HoseProductOption;
